/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespContainer_displayInfo$ref = any;
type PdpRespContainer_item$ref = any;
type PdpRespContainer_sellerItems$ref = any;
type PdpRespContainer_shipment$ref = any;
type PdpRespContainer_shipmentQuote$ref = any;
type PdpRespContainer_similarGridItems$ref = any;
type PdpRespContainer_similarLandingItems$ref = any;
type PdpRespContainer_transactions$ref = any;
type PdpRespContainer_user$ref = any;
type PdpRespContainer_viewer$ref = any;
type PdpRespContainer_vipUserRelationship$ref = any;
type PdpSharedLayout_user$ref = any;
type PdpSharedLayout_viewer$ref = any;
export type PdpRespLayout_viewer$ref = any;
export type PdpRespLayout_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": PdpRespContainer_user$ref & PdpSharedLayout_user$ref;
    } | null;
    readonly vipUserRelationships?: ReadonlyArray<{
        readonly " $fragmentRefs": PdpRespContainer_vipUserRelationship$ref;
    } | null> | null;
    readonly item: {
        readonly displayInfo?: {
            readonly " $fragmentRefs": PdpRespContainer_displayInfo$ref;
        } | null;
        readonly sellerItems?: {
            readonly " $fragmentRefs": PdpRespContainer_sellerItems$ref;
        } | null;
        readonly similarLandingItems: {
            readonly " $fragmentRefs": PdpRespContainer_similarLandingItems$ref;
        } | null;
        readonly similarGridItems: {
            readonly " $fragmentRefs": PdpRespContainer_similarGridItems$ref;
        } | null;
        readonly " $fragmentRefs": PdpRespContainer_item$ref;
    } | null;
    readonly relevantShipping: {
        readonly shipmentQuote: {
            readonly " $fragmentRefs": PdpRespContainer_shipmentQuote$ref;
        } | null;
        readonly shipment: {
            readonly " $fragmentRefs": PdpRespContainer_shipment$ref;
        } | null;
    } | null;
    readonly transactions: {
        readonly " $fragmentRefs": PdpRespContainer_transactions$ref;
    } | null;
    readonly " $fragmentRefs": PdpRespContainer_viewer$ref & PdpSharedLayout_viewer$ref;
    readonly " $refType": PdpRespLayout_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v1 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "PdpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "relationshipUserIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "pageType",
          "value": "PDP"
        }
      ],
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "similarLandingItems",
          "name": "moreLikeThis",
          "storageKey": "moreLikeThis(first:12)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 12
            }
          ],
          "concreteType": "moreLikeThisConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_similarLandingItems",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "similarGridItems",
          "name": "moreLikeThis",
          "storageKey": "moreLikeThis(first:8,seller:\"EXCLUDE\")",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 8
            },
            {
              "kind": "Literal",
              "name": "seller",
              "value": "EXCLUDE"
            }
          ],
          "concreteType": "moreLikeThisConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_similarGridItems",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainer_item",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isClient",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "displayInfo",
              "storageKey": null,
              "args": [
                (v1/*: any*/),
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "ItemDisplayInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_displayInfo",
                  "args": null
                }
              ]
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchPdp",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "sellerItems",
              "name": "moreLikeThis",
              "storageKey": "moreLikeThis(first:4,seller:\"INCLUDE\")",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4
                },
                {
                  "kind": "Literal",
                  "name": "seller",
                  "value": "INCLUDE"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_sellerItems",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuote",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipmentQuote",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipment",
          "storageKey": null,
          "args": null,
          "concreteType": "Shipment",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_shipment",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemIds"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespContainer_transactions",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "vipUserRelationships",
          "name": "userRelationships",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "relationshipUserIds"
            }
          ],
          "concreteType": "UserRelationship",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_vipUserRelationship",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '6b18790c68ec2d47c791282bf0f37720';
export default node;
